<mat-card>


  <div class="card-title-row">
    <mat-card-title>Search for events</mat-card-title>

    <mat-card-title class="right-title">
      <span class="dot"> </span>
       {{ errorsCount }} error(s) in last 24 hours
    </mat-card-title>
  </div>
  
  @if (loading) {
    <div class="spinner-container">
      <div class="spinner"></div>
    </div>
  }

  <div class="filter-row">
    <!-- Event Name Dropdown -->
    <mat-form-field appearance="outline" class="event-name-field">
      <mat-label>Event Name</mat-label>
      <mat-select [(ngModel)]="eventName">
        <mat-option [value]="null">-</mat-option>
        @for (event of eventOptions; track event) {
          <mat-option [value]="event.Name">
            {{ event.Name }} - {{ event.FriendlyName }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="master-code-field">
      <mat-label>Master Code</mat-label>
      <input matInput [(ngModel)]="masterCode" (keyup.enter)="applySearch()">
    </mat-form-field>

    <!-- Severity Dropdown -->
    <mat-form-field appearance="outline" class="severity-field" >
      <mat-label>Severity</mat-label>
      <mat-select [(ngModel)]="severityLevel">
        <mat-option [value]="null">-</mat-option>
        @for (option of severityOptions; track option) {
          <mat-option [value]="option.value">
            {{ option.label }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <!-- Source System Dropdown -->
    <mat-form-field appearance="outline" class="source-field">
      <mat-label>Source System </mat-label>
      <mat-select [(ngModel)]="sourceSystem">
        <mat-option [value]="null">-</mat-option>
        @for (source of sourceSystems; track source) {
          <mat-option [value]="source.Name">
            {{ source.Name }} - {{ source.FriendlyName }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <!-- Target System Dropdown -->
    <mat-form-field appearance="outline" class="target-field">
      <mat-label>Target System </mat-label>
      <mat-select [(ngModel)]="targetSystem">
        <mat-option [value]="null">-</mat-option>
        @for (target of targetSystems; track target) {
          <mat-option [value]="target.Name">
            {{ target.Name }} - {{ target.FriendlyName }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <button
      mat-flat-button
      color="primary"
      (click)="applySearch()"
      [disabled]="!eventName && !masterCode">
      Search
    </button>
    <button mat-flat-button (click)="clearFilters()">Clear</button>
  </div>

  <!--<mat-card-title>Filter for events</mat-card-title>

  <div class="clean-row">
    <mat-form-field appearance="outline" class="filter-field">
      <mat-label>Filter</mat-label>
      <input matInput [(ngModel)]="filter" (keyup)="applyFilter($event)" placeholder="Filter info">
    </mat-form-field>
    <button color="primary" mat-flat-button (click)="CleanFilter()">Clear</button>
  </div>-->

  <table mat-table [dataSource]="groupedData" class="mat-elevation-z8">
    <!-- Group Header Row -->
    <ng-container matColumnDef="groupHeader">
      <td mat-cell *matCellDef="let row" colspan="999" class="group-header">
        <div class="group-header-content">
          <span>
            Event : <b>{{ row.EventName }} ( ID : {{ row.EventId }} ) </b>
          </span>
          <span class="details">
            <mat-icon inline>open_in_new</mat-icon>
            <a [href]="'private/Tracking/Event/' + row.EventId" target="_blank" rel="noopener">
              Details
            </a>
          </span>

        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="severity">
      <th mat-header-cell *matHeaderCellDef> Severity </th>
      <td mat-cell *matCellDef="let trace">  {{ getSeverityLabel(trace.SeverityLevel) }} </td>
    </ng-container>

    <ng-container matColumnDef="masterCode">
      <th mat-header-cell *matHeaderCellDef> Master Code </th>
      <td mat-cell *matCellDef="let trace"> {{ trace.MasterCode }} </td>
    </ng-container>

    <ng-container matColumnDef="message">
      <th mat-header-cell *matHeaderCellDef> Message </th>
      <td mat-cell *matCellDef="let trace">
        {{ trace.FriendlyMessage || trace.Message }}
      </td>
    </ng-container>

    <ng-container matColumnDef="timeStamp">
      <th mat-header-cell *matHeaderCellDef> Time </th>
      <td mat-cell *matCellDef="let trace"> {{ trace.TimeStamp | date: 'dd/MM/yyyy HH:mm:ss' }} </td>
    </ng-container>

    <ng-container matColumnDef="sourceSystem">
      <th mat-header-cell *matHeaderCellDef> Source System </th>
      <td mat-cell *matCellDef="let trace">
        {{ trace.Systems?.Source?.FriendlyName || '—' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="targetSystem">
      <th mat-header-cell *matHeaderCellDef> Target System </th>
      <td mat-cell *matCellDef="let trace">
        {{ trace.Systems?.Target?.FriendlyName || '—' }}
      </td>
    </ng-container>

    <!-- Actions Column -->
    <!--<ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef> Actions </th>
    <td mat-cell *matCellDef="let trace">
      <a
        [href]="'private/Tracking/Event/'+ trace.EventId"
        target="_blank"
        rel="noopener"
        >
        Details
      </a>
    </td>
  </ng-container>-->

  <!-- Group Header Row -->
  <tr mat-row *matRowDef="let row; columns: ['groupHeader'] when: isGroup" class="group-row"></tr>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

  <!-- Row 1: Regular Data Row -->
  <tr
    mat-row
    *matRowDef="let row; columns: displayedColumns when: isData"
      [ngClass]="{
        'severity-1': row.SeverityLevel === '1',
        'severity-2': row.SeverityLevel === '2',
        'severity-3': row.SeverityLevel === '3'
      }">
  </tr>
</table>
</mat-card>
